module.exports = __webpack_public_path__ + "img/cidis.9da408b3.png";